<template lang="pug">
  //p RECTANGLE {{bounds}}
</template>
<script>
export default {
  props:{
    parentContainer:{
      required:true,
      type:Object
    },
    center:{
      type:Object,
      required:true
    },
    radius:{
      type:Number,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    lineWidth:{
      type:Number,
      default:0
    }
  },
  beforeDestroy() {
    this.graphics.parent.removeChild(this.graphics);
    this.renderTools.addToRunBatch( () => {
    });
  },
  mounted() {
    this.graphics = new PIXI.Graphics();
    if (this.lineWidth > 0) {
      this.graphics.lineStyle(this.lineWidth, 0xff00ff);
    }
    this.graphics.beginFill(0xff00ff);

    console.log('draw recantgle', this.bounds);
    this.graphics.drawCircle(this.center.x,
      this.center.y,
      this.radius
    );
    this.graphics.endFill();

    //this.group = new PIXI.display.Group(9999);
    //this.graphics.parentGroup = this.group
    //this.layer = new PIXI.display.Layer(this.group);
    this.parentContainer.addChild(this.graphics);
    //this.editobjects.d3Objects.app.stage.addChild(this.layer)
    this.renderTools.addToRunBatch(this.update.bind(this));



  },
  methods:{
    update() {
      this.graphics.clear();
      if (this.lineWidth > 0) {
        this.graphics.lineStyle(this.lineWidth, 0xff00ff);
      }
      this.graphics.beginFill(0xff00ff);

      console.log('draw recantgle', this.bounds);
      this.graphics.drawCircle(this.center.x,
        this.center.y,
        this.radius
      );
      this.graphics.endFill();
    }
  },
  watch:{
    'center.x'() {
      this.renderTools.addToRunBatch(this.update.bind(this));
    },
    'center.y'() {
      this.renderTools.addToRunBatch(this.update.bind(this));
    },
    'radius'() {
      this.renderTools.addToRunBatch(this.update.bind(this));
    }
  }
}
</script>
